import React from 'react';
import { TextareaField as TextareaFieldType } from '../../types/optionTypes';

interface TextareaFieldProps {
    field: TextareaFieldType;
    value: any;
    onChange: (value: any) => void;
}

export const TextareaField: React.FC<TextareaFieldProps> = ({ field, value, onChange }) => {
    return (
        <div className={`col-span-${field.col}`}>
            {field.label && (
                <label className="block text-sm font-medium text-gray-800 mb-2">
                    {field.label}
                    {field.required && <span className="text-red-500 ml-1">*</span>}
                </label>
            )}

            <textarea
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                placeholder={field.placeholder}
                required={field.required}
                rows={field.rows || 3}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors hover:border-gray-400"
            />

            {field.description && (
                <div className="mt-1.5 text-xs text-gray-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: field.description }} />
            )}
        </div>
    );
};
